// page: question add -------------------------------
function choicesCurrentNum() {
  const size = $('.questionBlock .card-text').length;
  if (size >= 10) {
    $('.choicesNumber').addClass('choicesNumberHigh');
  } else if (size === 2) {
    $('.choicesNumber').addClass('choicesNumberLow');
  } else {
    $('.choicesNumber').removeClass('choicesNumberLow choicesNumberHigh');
  }
  return size;
}
export function addRadio() {
  const radioName = `Easy${new Date().getTime()}`;
  const radioID = `Easy${new Date().getTime()}`;
  const inputGroupSelect = $('#inputGroupSelect option').val();
  const radioQuestion = $(`
        <div class="questionBlock ${inputGroupSelect} Easy">
          <div class="ribbon">
            <span class="Easy">Easy</span>
          </div>
          <div class="questionHeader">
            <h3 contenteditable="true" class="card-title  mb-3">
              اضغط للتعديل على السؤال !
            </h3>
          </div>
          <div class="questionBody singleMulti">
            <div class="card-text mb-2 alignVertical">
              <input type="radio" id="${radioID+1}" name=${radioName}>
              <label for="${radioID+1}" contenteditable="true">اجابه 1</label>
            </div>
            <div class="card-text mb-2 alignVertical">
              <input type="radio" id="${radioID+2}" name=${radioName}>
              <label for="${radioID+2}" contenteditable="true">اجابه 2</label>
            </div>
            <div class="card-text mb-2 alignVertical">
              <input type="radio" id="${radioID+3}" name=${radioName}>
              <label for="${radioID+3}" contenteditable="true">اجابه 3</label>
            </div>
          </div>
        </div>
    `);

  $('.questionPlace').append(radioQuestion);
}
export function choicesDecrease() {
  $('.questionBlock')
    .find('.editable-focus')
    .removeClass('editable-focus');
  $('.questionBlock input').prop('checked', false);
  const spanNum = $('.choicesNumber span').html();
  if (spanNum !== '2') {
    $('.questionBlock .alignVertical:last-child').remove();
    // reset all class
    $('.choicesNumber span').removeClass();
    // fade old number out
    $('.choicesNumber span').addClass('fadeOutDown');
    // fade new number in
    window.setTimeout(function () {
      $('.choicesNumber').html(`<span class="fadeInDown">${choicesCurrentNum()}</span>`);
    }, 100);
  }
}
export function choicesIncrease() {
  $('.questionBlock')
    .find('.editable-focus')
    .removeClass('editable-focus');
  $('.questionBlock input').prop('checked', false);

  const choiceNum = choicesCurrentNum();
  const idValue = `id${new Date().getTime() + choiceNum}`;
  const inc = $('.questionBlock .alignVertical:last-child').clone();
  inc.insertAfter('.questionBlock .alignVertical:last-child');
  // give radio new id
  $('.questionBlock .alignVertical:last-child input').prop('id', idValue);
  // give label for="id"
  $('.questionBlock .alignVertical:last-child label').text(
    `اجابه ${choiceNum + 1}`,
  ).prop('for', idValue);
  // reset all class
  $('.choicesNumber span').removeClass();
  // fade old number out
  $('.choicesNumber span').addClass('fadeOutUp');
  // fade new number in
  window.setTimeout(function () {
    $('.choicesNumber').html(`<span class="fadeInUp">${choicesCurrentNum()}</span>`);
  }, 100);
}
export function contentEditClicked() {
  $(this).parents('.questionBody ').find('input').prop('checked', false);
  $(document)
    .find('[contenteditable="true"]')
    .removeClass('editable-focus');
  $(this).addClass('editable-focus');
}

export function changeLevel() {
  const level = $('.questioncontrols__content-level input:checked').prop('id');
  const levels = ['Easy', 'Intermediate', 'Hard'];
  const otherlevels = levels.filter(el => el !== level).join(' ');
  const newName = `${level}${new Date().getTime()}`;
  const radioID = `${level}${new Date().getTime()}`;
  const inputGroupSelect = $('#inputGroupSelect').find(':selected').val();

  $('.alignVertical input').prop('name', newName).prop('id', radioID);
  $('.alignVertical label').prop('for', radioID);

  $('.questionBlock').removeClass().addClass(`questionBlock ${inputGroupSelect} ${level}`);
  $('.ribbon span').removeClass(otherlevels).addClass(`${level}`).text(level);
}

// page: question view ----------------------------------------
export function questionEdit() {
  if ($(this).hasClass('questionEdit')) {
    $(this).text('DONE').removeClass('questionEdit').addClass('questionDone');
    $(this).parent().find('.card-text label').prop('contenteditable', true);
    $(this).parent().find('.questionHeader h3').prop('contenteditable', true);
  } else if ($(this).hasClass('questionDone')) {
    $(this).text('EDIT').removeClass('questionDone').addClass('questionEdit');
    $(this).parent().find('.questionHeader h3').prop('contenteditable', false).removeClass('editable-focus');
    $(this).parent().find('.card-text label').prop('contenteditable', false).removeClass('editable-focus');
  }
}
export function questionsviewControls() {
  const deleteQs = $(`<span class="modalOpener questionDelete delete btn btn-outline-danger" title="Delete Question" data-toggle="modal" data-target="#deleteModal">DELETE</span>`);
  const editQs = $(`<span class="questionEdit btn btn-outline-primary" title="Edit Question">EDIT</span>`);
  $(this).prepend(editQs).prepend(deleteQs);
}
// page: question category -----------------------------------



//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/question/_question.js
// module id = 21
// module chunks = 0